export enum ReactionPreferenceOptionsForCompany {
  ALL_USERS = 0,
  TURN_ON_DEFAULT = 1,
  TURN_OFF_DEFAULT = 2,
}
export enum ReactionPreferenceOptionsForUser {
  TURN_OFF_DEFAULT = 0,
  TURN_ON_DEFAULT = 1,
}
